import * as React from 'react';
import './index.css';
import { generateSeperatorTags } from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/utils';

interface IState {}

interface Props {
  model: any;
}

export default class DeliveryFeeItemView extends React.Component<Props, IState> {
  render() {
    const { model } = this.props;
    const icon = model.icon;
    const richContent: any = generateSeperatorTags() || [];
    return (
      <view className="delivery-fee-item-container">
        { model.showSeperator && (
          <view className="delivery-fee-item-seperator-wrapper">
            <rich-text className="delivery-fee-item-seperator" content={richContent} />
          </view>
        )}
        <view className="delivery-fee-item-icon-wrapper" style={{ paddingTop: Mach.env.isIOS ? 1 : 1 }}>
          <image className="delivery-fee-item-icon" src={icon} />
        </view>
        <view className="delivery-fee-item-text-wrapper">
          <rich-text className="delivery-fee-item-text" content={model.richContents()} />
        </view>
      </view>
    );
  }
}
